<template>
  <div>
    <div class="body-wrapper">
      <modal-confirm-action
        v-if="showDeleteDocumentModal"
        @close="showDeleteDocumentModal = false"
        @confirm="deleteDocument"
        :isLoading="deleteLoading"
        title="Brisanje dokumenta"
      >
        <div>Da li ste sigurni da želite da obrišete dokument:</div>
        <div>{{ documentToDelete.file_name }}</div>
      </modal-confirm-action>
      <div class="left-column">
        <div class="box">
          <div class="title-wrapper flex main-header">
            <b class="title">Informacije</b>
            <div>
              <i
                class="fas fa-pen"
                @click="showModal('ModalContentEditCommunityInfrastructure')"
              ></i>
              <i
                class="fas fa-trash"
                @click="showModal('ModalContentDeleteCommunityInfrastructure')"
              ></i>
            </div>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="info-box">
            <div class="left-column" v-if="!loading">
              <div class="div-description single-info">
                <small class="label">Naziv</small>
                <h4 class="value">{{ infrastructure.name }}</h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Opis</small>
                <h4 class="value">
                  {{
                    infrastructure.description
                      ? infrastructure.description
                      : '/'
                  }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Kategorija</small>
                <h4 class="value">
                  {{ infrastructure.infrastructure_type }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="box invoices">
          <div class="title-wrapper">
            <b class="title">Dokumenta</b>
            <a
              class="btn"
              @click="showModal('ModalContentAddInfrastructureDocument')"
            >
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="table" v-if="!loading">
            <div v-if="infrastructure.medias.length == 0">
              Ne postoje dokumenta
            </div>
            <div ref="rows" class="rows">
              <div
                class="row"
                v-for="row in infrastructure.medias"
                :key="row.id"
              >
                <div class="parent">
                  <a
                    class="column document-name"
                    style="flex: 6"
                    target="_blank"
                    :href="baseObjectStorageUrl + row.link"
                  >
                    {{ row.file_name }}
                  </a>
                  <div class="column actions" style="flex: 1">
                    <a class="btn" @click="openDeleteDocument(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                    <a
                      class="btn"
                      target="_blank"
                      :href="baseObjectStorageUrl + row.link"
                    >
                      <i class="fas fa-file-download"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="box transactions">
          <div class="title-wrapper">
            <b class="title">Serviseri</b>
            <a class="btn" @click="openAddContractor">
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="table" v-if="!loading">
            <div v-if="infrastructure.contractors.length == 0">
              Ne postoje serviseri
            </div>
            <div ref="rows" class="rows">
              <div
                class="row"
                v-for="row in infrastructure.contractors"
                :key="row.id"
                :class="{
                  'expanded-content': row.isExpanded
                }"
              >
                <div class="parent">
                  <div class="column more">
                    <a class="more-btn" @click="toggleItems(row)">
                      <i class="fas fa-chevron-right"></i>
                    </a>
                  </div>
                  <div class="column">
                    {{ row.contractor.name }}
                  </div>
                  <div class="column actions contractor-details">
                    <a class="btn" @click="openDeleteContractor(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                    <a class="btn" :href="'/#/contractor/' + row.contractor.id">
                      <i class="fas fa-info-circle"></i>
                    </a>
                  </div>
                </div>
                <div class="items">
                  <div class="">
                    <div class="row-desc">Opis:</div>
                    <div class="column">
                      {{
                        row.contractor.description
                          ? row.contractor.description
                          : '/'
                      }}
                    </div>
                    <div v-if="row.contact.name" class="row-desc">
                      Kontakt osoba:
                    </div>
                    <div v-if="row.contact.name" class="column">
                      {{ row.contact.name }}
                    </div>
                    <div v-if="row.contact.description" class="row-desc">
                      Opis kontakt osobe:
                    </div>
                    <div v-if="row.contact.description" class="column">
                      {{ row.contact.description }}
                    </div>
                    <div v-if="row.contact.phone" class="row-desc">
                      Telefon:
                    </div>
                    <div v-if="row.contact.phone" class="column">
                      {{ row.contact.phone }}
                    </div>
                    <div v-if="row.contact.email" class="row-desc">Email:</div>
                    <a
                      v-if="row.contact.email"
                      class="column"
                      :href="'mailto: ' + row.contact.email"
                      >{{ row.contact.email }}</a
                    >

                    <!-- <div class="column">{{ row.email }}</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import axios from '@/axios/axios.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';

export default {
  name: 'CommunityFinancesMember',
  mixins: [addSeparatorMixin],
  components: {
    modalConfirmAction
  },
  data() {
    return {
      baseObjectStorageUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      showDeleteDocumentModal: false,
      documentToDelete: null,
      deleteLoading: false
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', [
      'tableColumns',
      'tableData',
      'tableOptions',
      'infrastructure'
    ])
  },
  async created() {
    this.cardOpened();
    this.setTableBadge('fas fa-tools');
    try {
      await this.getInfrastructureCategories();
      await this.getInfrastructureById(this.$route.params.infrastructureId);
    } catch (error) {
      if (error.response.status == 404) {
        this.$router.push('/notFound');
      } else {
        console.log(error);
        this.showFailModal();
        this.back();
      }
    }
  },
  destroyed() {
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', [
      'setTableData',
      'setTableBadge',
      'setInfrastructure'
    ]),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', [
      'getInfrastructureById',
      'getInfrastructureCategories'
    ]),
    ...mapMutations('modal', [
      'showModal',
      'setInfrastructure',
      'setContractor'
    ]),

    back() {
      this.$router.back();
    },
    openAddContractor() {
      this.setInfrastructure(this.infrastructure);
      this.showModal('ModalContentAddInfrastructureContractor');
    },
    openDeleteContractor(contractor) {
      this.setContractor(contractor);
      this.setInfrastructure(this.infrastructure);
      this.showModal('ModalContentDeleteInfrastructureContractor');
    },
    toggleItems(contact) {
      contact.isExpanded = !contact.isExpanded;
      // FIXME Find a way to detect change without this
      this.infrastructure.contractors = [...this.infrastructure.contractors];
    },
    openDeleteDocument(document) {
      this.documentToDelete = document;
      this.showDeleteDocumentModal = true;
    },
    async deleteDocument() {
      try {
        this.deleteLoading = true;
        const data = {
          communityId: this.$store.getters.getActiveCommunity.id,
          memberId: this.$store.getters.getActiveCommunity.member_id,
          mediaId: this.documentToDelete.id,
          communityInfrastructureId: this.$route.params.infrastructureId
        };
        await axios.post('infrastructure/delete-media', data);
        await this.getInfrastructureById(this.$route.params.infrastructureId);
        this.deleteLoading = false;
        this.showSuccessModal();
        this.showDeleteDocumentModal = false;
      } catch (error) {
        console.log(error);
        this.deleteLoading = false;
        this.showFailModal();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main-header {
  align-items: center;
  justify-content: space-between;
  i {
    cursor: pointer;
  }
  .fa-pen {
    color: var(--primary-color);
  }
  .fa-trash {
    margin-left: 16px;
    color: var(--danger-color);
  }
}
.header-contractor {
  margin-bottom: 40px;
  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}
.contractor-details {
  margin-left: auto;
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 2;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 3;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
          .more {
            margin-right: 8px;
          }
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 100%;
          flex-direction: column;
          padding-left: 8px;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.flex {
  display: flex;
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
